import React from 'react';
import Gallery from '../../models/gallery.model';
import LightBox from '../Lightbox';

interface GCprops{
image:string,
images:Array<Gallery>,
active:number
}

const GalleryCard:React.FC<GCprops> = props =>{
  const {image,images,active} = props;
return(
  <>
    <div className="ecn-gallery-card">
      <img src={image} alt="" className="img-fluid"/>
      <div className="overlay">
        <LightBox images={images} active={active}/>
      </div>
    </div>
  </>
);
}

export default GalleryCard;